
export enum PaymentProviderActionResult {
  Voided= 'Voided',
  Captured= 'Captured',

}